import { StateCreator } from 'zustand'

interface User {
  id: string
  name: string
  email: string
  avatar?: string
  role: 'admin' | 'user' | 'client'
}

export interface AuthSlice {
  auth: {
    user: User | null
    isAuthenticated: boolean
    isLoading: boolean
    login: (email: string, password: string) => Promise<void>
    logout: () => void
    register: (userData: Partial<User> & { password: string }) => Promise<void>
    updateProfile: (userData: Partial<User>) => Promise<void>
    resetPassword: (email: string) => Promise<void>
  }
}

export const createAuthSlice: StateCreator<AuthSlice> = (set) => ({
  auth: {
    user: null,
    isAuthenticated: false,
    isLoading: false,

    login: async (email: string, _password: string) => {
      set((state) => ({
        auth: {
          ...state.auth,
          isLoading: true,
        },
      }))

      try {
        // Simular llamada a API
        await new Promise((resolve) => setTimeout(resolve, 1000))

        const mockUser: User = {
          id: '1',
          name: 'Usuario Demo',
          email,
          role: 'client',
        }

        set((state) => ({
          auth: {
            ...state.auth,
            user: mockUser,
            isAuthenticated: true,
            isLoading: false,
          },
        }))
      } catch (error) {
        set((state) => ({
          auth: {
            ...state.auth,
            isLoading: false,
          },
        }))
        throw error
      }
    },

    logout: () => {
      set((state) => ({
        auth: {
          ...state.auth,
          user: null,
          isAuthenticated: false,
        },
      }))
    },

    register: async (userData) => {
      set((state) => ({
        auth: {
          ...state.auth,
          isLoading: true,
        },
      }))

      try {
        // Simular llamada a API
        await new Promise((resolve) => setTimeout(resolve, 1000))

        const newUser: User = {
          id: Math.random().toString(36).substr(2, 9),
          name: userData.name || '',
          email: userData.email || '',
          role: 'client',
        }

        set((state) => ({
          auth: {
            ...state.auth,
            user: newUser,
            isAuthenticated: true,
            isLoading: false,
          },
        }))
      } catch (error) {
        set((state) => ({
          auth: {
            ...state.auth,
            isLoading: false,
          },
        }))
        throw error
      }
    },

    updateProfile: async (userData) => {
      set((state) => ({
        auth: {
          ...state.auth,
          isLoading: true,
        },
      }))

      try {
        // Simular llamada a API
        await new Promise((resolve) => setTimeout(resolve, 500))

        set((state) => ({
          auth: {
            ...state.auth,
            user: state.auth.user ? { ...state.auth.user, ...userData } : null,
            isLoading: false,
          },
        }))
      } catch (error) {
        set((state) => ({
          auth: {
            ...state.auth,
            isLoading: false,
          },
        }))
        throw error
      }
    },

    resetPassword: async (_email: string) => {
      set((state) => ({
        auth: {
          ...state.auth,
          isLoading: true,
        },
      }))

      try {
        // Simular llamada a API
        await new Promise((resolve) => setTimeout(resolve, 1000))

        set((state) => ({
          auth: {
            ...state.auth,
            isLoading: false,
          },
        }))
      } catch (error) {
        set((state) => ({
          auth: {
            ...state.auth,
            isLoading: false,
          },
        }))
        throw error
      }
    },
  },
}) 